export const BACK_CARD_NAME = 'ww';
